import { Trans, useTranslation } from 'react-i18next';
import { AqarmapProSourceEnum } from '~/constants/enums';
import { useFullRoutes } from '~/hooks';
import { formatNumber } from '~/lib';
import { CreditPackageType } from '~/types/packagesType';
import { sendGTMEvent } from '~/utils';

export default function PackageSummary({
  packageDetails,
}: {
  packageDetails: CreditPackageType;
}) {
  const { PACKAGES_URL } = useFullRoutes();
  const { t } = useTranslation('app');
  const priceBeforeDiscount = packageDetails.price;
  const priceAfterDiscount = packageDetails.price_after_discount ?? 0;
  const discountPercentage = packageDetails.discount_percentage;
  const activationFee = Number(packageDetails.activation_fee || 0);
  const amountOfDiscount = priceAfterDiscount - priceBeforeDiscount;
  const taxes = Number(packageDetails.taxes || 0);
  const taxesPercentage = Number(packageDetails.taxes_percentage || 0);

  return (
    <>
      <div className="flex justify-between w-full mb-3x">
        <p className="text-title_4 ">{packageDetails.title}</p>
        <button
          onClick={() => {
            sendGTMEvent({
              event: 'gtm-aqarmap_pro',
              subscribe_source: AqarmapProSourceEnum.MY_ACCOUNT,
            });
            window.location.href = PACKAGES_URL.ROOT;
          }}
          className="text-link text-blue "
        >
          {t('change')}
        </button>
      </div>

      <div className="flex flex-col ">
        <div className="flex justify-between border-b border-gray pb-1.5x mb-1.5x">
          <p className="text-body-2">{t('planPrice')}</p>
          <p className="text-caption-1 text-gray__dark_2">{`${priceBeforeDiscount.toLocaleString()} ${t('egp')}`}</p>
        </div>
        <div className="flex flex-col gap-x">
          {activationFee ? (
            <div className="flex justify-between ">
              <p className="text-caption-1">
                <Trans
                  i18nKey="activationFees"
                  t={t}
                  components={{
                    tag: <span className=" text-gray__dark_1" />,
                  }}
                />
              </p>
              <p className="text-caption-1 text-gray__dark_2">
                {formatNumber(activationFee)} {t('egp')}
              </p>
            </div>
          ) : null}
          {taxes ? (
            <div className="flex justify-between items-center">
              <p className="text-caption-1 text-black">
                {t('vatValue', { value: `${taxesPercentage}%` })}
              </p>
              <p className="text-caption-1 text-gray__dark_2">
                {formatNumber(taxes)} {t('egp')}
              </p>
            </div>
          ) : null}
          {discountPercentage ? (
            <div className="flex justify-between ">
              <p className="text-body-2 text-green_dark ">
                {t('discountPercentage', { percentage: discountPercentage })}
              </p>
              <p className="text-caption-1 text-green_dark">
                {amountOfDiscount.toLocaleString()} {t('egp')}
              </p>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}
